<template>
    <b-container fluid>
        <colab-header></colab-header>
        <transition name="slide" mode="out-in">
            <router-view></router-view>
        </transition>
        <vue-snotify></vue-snotify>
    </b-container>
</template>

<script>
import i18n from '@/i18n.bootstrap';
import ColabHeader from './components/Header';
import reloadService from './shared/reload-ui.js';

export default {
    components: { ColabHeader },
    
    computed: {
        reloadUI() {
            return this.$store.getters['system/reloadUI'];
        }
    },

    watch: {
        reloadUI() {
            if (this.reloadUI !== undefined) {
                this.$snotify.confirm(i18n.t('general.reloadAppQuestion'), '', {
                    closeOnClick: true,
                    position: 'rightBottom',
                    buttons: [
                        {text: i18n.t('general.yes'), action: reloadService.reloadApp},
                        {text: i18n.t('general.no'), action: reloadService.cancelReload}
                    ]
                });
            }
        }
    },

    created() {
        setInterval(()=> {
            this.$store.dispatch('system/loadGlobalConfiguration');
        }, 300000);

        // Checking storage events - multitab user sync
        window.addEventListener('storage', function(event){
            if (event.key == 'login' && event.newValue != 0) { 
                reloadService.reloadAppAndUserData();
            }
        });
    },
}
</script>


<style lang="scss">
@import './styles/custom-theme.scss';
@import '../node_modules/bootstrap/scss/bootstrap.scss';
@import '../node_modules/bootstrap-vue/dist/bootstrap-vue.css';
@import './styles/global-styles.scss';
</style>
